module.exports = __webpack_public_path__ + "img/Ley.5a58dbe7.svg";